<div class="container-fluid pt-4 pb-4">
  <h1>Veðurspáin fyrir Bláfjöll</h1>
  <div class="spain">
    <div class="spa">
      <iframe src="https://blika.is/iframe/149/5/is" title="Veðrið"></iframe>
    </div>
  </div>
</div>
